<template>
    <v-layout>
         <!-- Apply for PC or Laptop -->
        <v-container class="hidden-sm-and-down">
            <v20d7010pc/>
        </v-container>
    </v-layout>    
</template>

<script>

import v20d7010pc from './popup/v20d7010pc'


export default {
    
    name: "v20d7010",
    components: {
       v20d7010pc 
    },
    props:{
       
    },
    data: () => ({  
       

    }),    
    mounted() {

     
    },
    methods : {

    }

    
}
</script>